import { FC } from "react";
import DataTable, { TableColumn } from "react-data-table-component";
import { useListView } from "../../../../shared/providers/ListView/ListView";
import { useThemeMode } from "../../../../../_metronic/partials";
import { NoDataComponent } from "../../../../shared/ListView/NoDataComponent";
import { IAPropiedadTercero } from "../../../../../interfaces/auditorias/IAPropiedadTercero";
import { BotonOpenModalAPT } from "../utils/BotonOpenModalAPT";
import { Accion } from "../../../../shared/misc/BotonesAttributos";
import date from "date-and-time"

const tableColumns: TableColumn<IAPropiedadTercero>[] = [
  {
    name: 'Usuario',
    selector: row => row.aNombreUsuario,
    sortable: true,
    wrap: true
  }, {
    name: 'Cliente Asignado',
    selector: row => row.tercero,
    sortable: true,
    wrap: true
  }, {
    name: 'Fecha',
    selector: row => date.format(row.aFecha, 'DD-MM-YYYY HH:mm'),
    sortFunction: (a, b) => a.aFecha.getTime() - b.aFecha.getTime(),
    sortable: true
  }, {
    name: 'IP',
    selector: row => row.aIp
  }, {
    name: 'Accion',
    selector: row => row.aTipoAccion,
    cell: (row) => <Accion accion={{nombre: row.aTipoAccion, valor: row.aTipoAccion}} />,
    center: true,
    width: "100px"
  }, {
    name: 'Acciones',
    cell: (row) => (
      <BotonOpenModalAPT tercero={row} />
    ),
    width: "80px",
    center: true
  }
]


export const AuditoriaPropiedadTLista: FC = () => {

  const { filterData, cargandoDatos } = useListView();
  const { mode } = useThemeMode();

  return (
    <div className="px-5">
      <DataTable
        columns={tableColumns}
        data={filterData}
        progressPending={cargandoDatos}
        pagination
        persistTableHead
        theme={mode == "dark" ? "dark" : "light"}
        noDataComponent={<NoDataComponent/>}
        keyField="idAuditoria"
        paginationComponentOptions={{
          rowsPerPageText: "Filas por pagina:"
        }}
      />
    </div>
  )
}

